import React from 'react';
import Grid from '@mui/material/Grid';

const LegacyGrid = React.forwardRef((props, ref) => {
  const {
    item,
    xs,
    sm,
    md,
    lg,
    xl,
    direction,
    sx = {},
    ...rest
  } = props;

  // Build the size prop
  const size = {};
  if (xs !== undefined) size.xs = xs === true ? 'grow' : xs;
  if (sm !== undefined) size.sm = sm === true ? 'grow' : sm;
  if (md !== undefined) size.md = md === true ? 'grow' : md;
  if (lg !== undefined) size.lg = lg === true ? 'grow' : lg;
  if (xl !== undefined) size.xl = xl === true ? 'grow' : xl;

  const hasSize = Object.keys(size).length > 0;
  
  const combinedSx = { ...sx };
  if (direction) {
    combinedSx.flexDirection = direction;
  }

  return (
    <Grid
      ref={ref}
      {...(hasSize ? { size } : {})}
      {...(direction ? { direction } : {})}
      sx={combinedSx}
      {...rest}
    />
  );
});

LegacyGrid.displayName = 'LegacyGrid';

export default LegacyGrid;
